import http from "../http-common"; // Adjust based on your Axios setup

class ReportsDataService {
    getDailyTripsReportData(date) {
        return http.get(`/reports/dailyTripsReport?date=${date}`);
    }
    getMedicalReportData(date) {
        return http.get(`/reports/medicalReport?date=${date}`);
    }
    getLunchReportData(date) {
        return http.get(`/reports/lunchReport?date=${date}`);
    }
    getDailyShuttleReportData(date) {
        return http.get(`/reports/dailyShuttleReport?date=${date}`);
    }
    getGroupListReportData(date) {
        return http.get(`/reports/groupListReport?date=${date}`);
    }
    getDailyRentalReportData(date) {
        return http.get(`/reports/dailyRentalReport?date=${date}`);
    }
    getWildlifeExportReportData(yearStart, yearEnd) {
        return http.get(`/reports/wildlifeExportReport?yearEnd=${yearEnd}&yearStart=${yearStart}`);
    }
    getZoneUsageReportData(yearStart, yearEnd) {
        return http.get(`/reports/zoneUsageReport?yearEnd=${yearEnd}&yearStart=${yearStart}`);
    }
    getSkierDaysReportData(yearStart, yearEnd) {
        return http.get(`/reports/skierDaysReport?yearEnd=${yearEnd}&yearStart=${yearStart}`);
    }
    getRunUsageReportData(yearStart, yearEnd) {
        return http.get(`/reports/runUsageReport?yearEnd=${yearEnd}&yearStart=${yearStart}`);
    }
}

export default new ReportsDataService();
